export default "__VITE_ASSET__eea62e32__"